import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BrokeFlexMessageService } from '../services/BrokeFlexMessageService'
import { MessagingQueryKey } from '../../keys'

interface UseMutationUpdateBrokeFlexMessageCampaignOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

export default function useMutationUpdateBrokeFlexMessageCampaign({
	onSuccess,
	onError,
}: UseMutationUpdateBrokeFlexMessageCampaignOptions = {}) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: { isActive: boolean } }) =>
			BrokeFlexMessageService.updateCampaign(id, data),
		onSuccess: () => {
			// Invalidate both the list and detail queries
			queryClient.invalidateQueries({
				queryKey: [MessagingQueryKey.GetBrokeFlexMessageCampaigns],
			})
			queryClient.invalidateQueries({
				queryKey: [MessagingQueryKey.GetBrokeFlexMessageCampaign],
			})
			onSuccess?.()
		},
		onError,
	})
}
